import DatePicker from "react-datepicker";
import "./styles.css";
const CustomDatePicker = ({ ...props }) => {
  return <DatePicker toggleCalendarOnIconClick {...props} calendarClassName="custom-datepicker"/>;
};

export default CustomDatePicker;
